import { VendorBuyOpportunityPermissions } from '../../../components/Vendor';

export function BuyOpportunityPermissions() {
  return <VendorBuyOpportunityPermissions />;
}
